// removed by extract-text-webpack-plugin
module.exports = {"root":"dh-stille-spesial-root","app":"dh-stille-spesial-app"};


//////////////////
// WEBPACK FOOTER
// ./src/v1/components/App.css
// module id = 8
// module chunks = 0